import { useEffect, useState } from "react";

import {
  arrange,
  date2FormattedString,
  string2Date,
  transpose,
} from "../../utils/utils";
import { adminEndpoints } from "../../api/endpoints";

export default function useClientRequestHeatmap(
  client,
  apiClient,
  isFocused = true,
) {
  const [heatmap, setHeatmap] = useState(null);

  const clearData = () => {
    setHeatmap(null);
  };

  const loadData = async () => {
    const response = await apiClient.get(
      adminEndpoints.clientrequestcounterheatmap,
      { client_id: client.id },
    );
    setHeatmap(response.data.heatmap);
  };

  const initData = loadData;

  useEffect(() => {
    if (isFocused) initData();
    else clearData();
  }, [isFocused]);

  const xTicks =
    heatmap &&
    heatmap.map((h) => date2FormattedString(string2Date(h.date), null));
  const yTicks = arrange(24).map((i) => `${String(i).padStart(2, "0")}:00`);
  const matrix = heatmap && transpose(heatmap.map((h) => h.values));

  return {
    ticks: { x: xTicks, y: yTicks },
    matrix,
    data: { update: loadData, clear: clearData, init: initData },
  };
}
